// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ng-1";
export var stateContainer = "_ng-0";